import LoginPageImage from "../../assets/LoginPageImage.png";
import { useDispatch, useSelector } from "react-redux";

import { useState, useEffect } from "react";
import { loginUser } from "../../Redux/userSlice";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { updatePassword } from "../../Redux/passResetSlice";
import RegisterPopUp from "../../components/auth/RegisterPopUp";
import { IoIosArrowRoundBack } from "react-icons/io";
import useAxios from "../../hooks/useAxios";
import axiosInstance from "../../apis/commonAPI";



const ForgotPassword = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const userRegisterToast = searchParams.get("userRegister");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, error } = useSelector((state) => state.user);
  const [loginCookie, setLoginCookie] = useCookies(["user"]);
  const [rememberCheck, setRememberCheck] = useState(loginCookie.RememberMe);
  const [modalOpen, setModalOpen] = useState(false);
  const [getOtpFlag, setGetOtpFlag] = useState(false);
  const [phoneInfo, setPhoneInfo] = useState(0);
  const [otpInfo, setOtpInfo] = useState(0);

  const form = useForm({
    defaultValues: {
      phone: loginCookie.Phone,
    },
  });
  const {
    register,
    control,
    handleSubmit,
    formState,
    watch,
    setValue,
    getValues,
  } = form;
  const { errors } = formState;
   const [resData, errorSubmit, loadingSubmit, axiosSubmit] =
       useAxios();

         const getOTPData = (url) => {
          axiosSubmit({
                       axiosInstance: axiosInstance,
                       url: url,
                       method: "GET",
                     });
                   };
  useEffect(() => {
    if (userRegisterToast === "success") {
      toast.success("User registered successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (userRegisterToast === "registered") {
      toast.success("Expert registered successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }, [userRegisterToast]);

  const handleSetCookiesCheck = (e) => {
    if (e.target.checked) {
      setRememberCheck(e.target.checked);
    } else {
      setRememberCheck(false);
      setLoginCookie("Phone", null, {
        path: "/",
        sameSite: "Strict",
        secure: false,
      }); //set samesite to either (none,Lax,or strict as per latest Doc RFC6265bis)
     
      
    }
  };

  const onFormSubmit = async (data) => {
    if (rememberCheck) {
      setLoginCookie("Phone", data.phone, {
        path: "/",
        sameSite: "Strict",
        secure: false,
      });
      
    } else {
      setLoginCookie("Phone", null, {
        path: "/",
        sameSite: "Strict",
        secure: false,
      });
     
    }
    setPhoneInfo(data.phone);
    getOTPData(`users/forgot-password-otp/${data.phone}`)
   setGetOtpFlag(true);
   
  };
  useEffect(() => {
    if(phoneInfo && getOtpFlag && resData?.[0]?.success){
      console.log("resData?.[0]?.data",resData?.[0]?.data)
    setModalOpen(true);

      setOtpInfo(resData?.[0]?.data);

      toast.success(resData?.[0]?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 500,
      })

    }else if(getOtpFlag && !resData?.[0]?.success){
    setModalOpen(false);

      toast.error(resData?.[0]?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 500,
      })

    }
    setGetOtpFlag(false);

  },[resData])
  
  function closeModal(getCloseFlag = "false") {
    setModalOpen(getCloseFlag);
  }

  return (
    
    <>
     
      <div className="login-section ">
      <div className="pc login-left">
        <div className="login-left-section">
          {/* */}
            <img
              className="login-sec-img"
              src={LoginPageImage}
              alt="Paramarsh"
            />
          </div>
        </div>

        <div className="login-right-section rounded-20 mt-10">
          <img className="login-sec-img" src={LoginPageImage} alt="Paramarsh" />
          <h2 className="text-pink text-center text-bold mt-15">Forget Password </h2>
          <ToastContainer />

          <form
            className="mt-20"
            onSubmit={handleSubmit(onFormSubmit)}
            noValidate
          >
            <div className="col-md-4  tank-col-info">
              <label htmlFor="phone" className="text-gray text-semi-bold">
                Mobile Number<span className="text-red">*</span>
              </label>
              <input
                  id="phone"
                  {...register("phone", {
                    required: {
                      value: true,
                      message: "Mobile Number field should contains atleast 10 digits",
                    },
                    pattern: {
                      value: /^[0-9]/,
                      message: "Only Digits are Allowed",
                    },
                    minLength: { value: 10, message: "Enter 10 digits" },
                    maxLength: { value: 10, message: "Enter 10 digits" },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter Mobile Number"
                />
              <p className="text-red mb-10">{errors.phone?.message}</p>
            </div>

           

           

            <input
              type="submit"
              className="btn btn-light-pink btn-full rounded-10 mt-10 mb-10"
              value={loading ? "Loading..." : "Get OTP"}
             
            />

            <RegisterPopUp modalOpen={modalOpen} closeModal={closeModal}  phoneData = {phoneInfo} otpData={otpInfo} otpHandle = {setOtpInfo} />
            
            <div className="text-Left no-bg">
              <span
                className="text-semi-bold text-pink"
                onClick={() => {
                  navigate("/login");
                }}
              >
                <IoIosArrowRoundBack />    Back to login
              </span>
            </div>
            <div className="text-Left no-bg">
              {/* <span
                className="text-semi-bold text-pink"
                onClick={() => {
                  setModalOpen(true);
                }}
              >
                Forgot Password ?
              </span> */}
               {/* <span
                className="text-semi-bold text-pink"
                onClick={() => {
                  navigate("/forgot-password");
                }}
              >
                Forgot Password ?
              </span> */}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
export default ForgotPassword;


